import { FETCH_ALL_PROJECTS_FOR_COUNTRY } from '../../constants/actionTypes'

export default (projectsForCountries = [], action) => {
    switch (action.type) {
        case FETCH_ALL_PROJECTS_FOR_COUNTRY:
            return action.payload;
        default:
            return projectsForCountries;
    }
}